module.exports = __webpack_public_path__ + "img/calendar_big.9d412038.svg";